import { createContext, useContext, useState } from "react";

const fr = {
  tagline1: "Bouger.", tagline2: "Explorer.", tagline3: "Récupérer.",
  patientMode: "MODE PATIENT", therapistMode: "MODE THÉRAPEUTE",
  stop: "ARRÊTER", stopSession: "ARRÊTER LA SÉANCE",
  simulated: "DONNÉES DE MOUVEMENT SIMULÉES",
  disclaimer: "Baobab Adventures est un outil d'aide à la rééducation et ne remplace pas l'évaluation ou le traitement par un professionnel de santé.",
  painToday: "Douleur aujourd'hui ?", fatigueToday: "Fatigue aujourd'hui ?",
  painNow: "Douleur maintenant ?", fatigueNow: "Fatigue maintenant ?",
  pauseMsg: "Faites une pause et informez votre professionnel de santé.",
  calibTitle: "Bao a besoin d'apprendre comment vous bougez.",
  calibDone: "CALIBRATION TERMINÉE", calibDoneSub: "Bao connaît maintenant votre zone de mouvement.",
  seedFound: "GRAINE DE VIE DÉCOUVERTE", plusSeed: "+1 Graine",
  nav_overview: "Vue d'ensemble", nav_patients: "Patients", nav_assessments: "Évaluations", nav_sessions: "Séances",
  nav_progress: "Progrès", nav_missions: "Missions", nav_settings: "Paramètres", nav_exercises: "Exercices",
};

const en = {
  tagline1: "Move.", tagline2: "Explore.", tagline3: "Recover.",
  patientMode: "PATIENT MODE", therapistMode: "THERAPIST MODE",
  stop: "STOP", stopSession: "STOP SESSION",
  simulated: "SIMULATED MOVEMENT DATA",
  disclaimer: "Baobab Adventures is a rehabilitation support tool and does not replace assessment or treatment by a healthcare professional.",
  painToday: "Pain today?", fatigueToday: "Fatigue today?", painNow: "Pain now?", fatigueNow: "Fatigue now?",
  pauseMsg: "Pause the session and inform your healthcare professional.",
  calibTitle: "Bao needs to learn how you move.",
  calibDone: "CALIBRATION COMPLETE", calibDoneSub: "Bao now knows your movement zone.",
  seedFound: "SEED OF LIFE DISCOVERED", plusSeed: "+1 Seed",
  nav_overview: "Overview", nav_patients: "Patients", nav_assessments: "Assessments", nav_sessions: "Sessions",
  nav_progress: "Progress", nav_missions: "Missions", nav_settings: "Settings", nav_exercises: "Exercises",
};

const DICTS = { fr, en };
const I18nCtx = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(localStorage.getItem("baobab.lang") || "fr");
  const setLang = (l) => { localStorage.setItem("baobab.lang", l); setLangState(l); };
  const t = (k) => DICTS[lang]?.[k] ?? fr[k] ?? k;
  const pick = (obj, base) => obj?.[`${base}_${lang}`] ?? obj?.[`${base}_fr`];
  return <I18nCtx.Provider value={{ lang, setLang, t, pick }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
